import React, { useContext } from "react";

import styled from "styled-components";
import { Link } from "gatsby";
import { useLocation } from "@reach/router";
import { useBreakpoint } from "gatsby-plugin-breakpoints";

import { useI18n, LocaleContext } from "../../../locale.js";

import cities from "../../cities.json";
import { I18nextContext } from "gatsby-plugin-react-i18next";

export const SelectCityPopover = ({
  visible,
  onClose,
  wrapperRef,
  currentCity,
}) => {
  const { pathname = "" } = useLocation();
  const { locale } = useContext(LocaleContext);
  const context = React.useContext(I18nextContext);

  const breakpoints = useBreakpoint();
  const country = useI18n("navbar.country");

  return (
    <CityPopoverStyled show={visible} ref={wrapperRef}>
      {breakpoints.tablet ? null : (
        <CityPopoverTitleStyled>{country}</CityPopoverTitleStyled>
      )}
      <ClosePopoverStyled onClick={onClose} />
      <CityListStyled>
        {cities
          .sort((a, b) => (a.name[context.language] < b.name[context.language] ? -1 : 1))
          .map((city) => (
            <li key={city.slug}>
              <ListItemLinkStyled
                to={pathname.replace(currentCity, city.slug)}
                onClick={() => onClose(city.companyId)}
              >
                {city.name[context.language]}
              </ListItemLinkStyled>
            </li>
          ))}
      </CityListStyled>
    </CityPopoverStyled>
  );
};

const CityPopoverStyled = styled.div`
  width: calc(100% - 30px);
  max-height: 75vh;
  padding: 25px 20px;

  position: absolute;
  left: 15px;
  top: 84px;

  background-color: ${(props) => props.theme.colors.white};
  transform: ${({ show }) => (show ? "translateY(0)" : "translateY(200px)")};

  opacity: ${({ show }) => (show ? "1" : "0")};
  visibility: ${({ show }) => (show ? "visible" : "hidden")};
  overflow: auto;
  transition: all 0.2s;
  @media ${(props) => props.theme.breakpoints.tablet} {
    padding: 25px;
    max-height: 80vh;
    max-width: 340px;
    margin: auto;

    left: 0;
    right: 0;
  }
`;

const CityPopoverTitleStyled = styled.p`
  margin-left: 10px;

  color: #979797;
  font-size: 0.9rem;
  text-transform: uppercase;
`;

const CityListStyled = styled.ul`
  display: grid;
  align-items: center;

  grid-template-columns: repeat(8, 1fr);
  grid-row-gap: 5px;
  grid-column-gap: 15px;
  margin-top: 10px;
  padding: 0;

  list-style: none;
  z-index: 1;
  @media ${(props) => props.theme.breakpoints.medium} {
    grid-template-columns: repeat(6, 1fr);
  }

  @media ${(props) => props.theme.breakpoints.tablet} {
    grid-template-columns: repeat(2, 1fr);
  }
`;

const ListItemLinkStyled = styled(Link)`
  display: inline-block;

  padding: 10px;

  border-bottom: 2px solid transparent;

  color: ${(props) => props.theme.colors.black};
  font-size: 1rem;
  transition: all 0.3s ease-in-out;
  &:hover {
    border-bottom-color: ${(props) => props.theme.colors.green};
  }
`;

const ClosePopoverStyled = styled.button`
  width: 20px;
  height: 20px;
  padding: 0px;

  position: absolute;
  right: 32px;
  top: 32px;

  background: none;
  border: none;

  opacity: 0.3;
  transition: 0.3s all;
  &:hover {
    opacity: 1;
  }
  &:before,
  &:after {
    content: " ";
    height: 21px;
    width: 2px;

    position: absolute;
    top: 0;
    left: 8px;

    background-color: ${(props) => props.theme.colors.green};
  }
  &:before {
    transform: rotate(45deg);
  }
  &:after {
    transform: rotate(-45deg);
  }

  @media ${(props) => props.theme.breakpoints.tablet} {
    right: 12px;
    top: 12px;
  }
`;
